import { useEffect, useState } from 'react';

import { Center, Container, Loader, ScrollArea, Stack } from '@mantine/core';

import * as Sentry from '@sentry/react';

import { LogoPaper, MarkdownParser, PageTitle } from '@/components';

export function DataSourcesPage() {
  const [content, setContent] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch('/content/data-sources.md')
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Failed to fetch data sources: ${response.status} ${response.statusText}`
          );
        }
        return response.text();
      })
      .then((text) => {
        setContent(text);
        setIsLoading(false);
      })
      .catch((error) => {
        Sentry.captureException(error);
        setIsLoading(false);
      });
  }, []);

  return (
    <Stack gap="xl" mb="md">
      <PageTitle
        title="Data Sources"
        subtitle="Information about our data integration partners and their coverage"
      />

      <Container size="sm" px={0}>
        <LogoPaper>
          <ScrollArea h="calc(100vh - 200px)" type="auto">
            {isLoading ? (
              <Center>
                <Loader />
              </Center>
            ) : (
              <MarkdownParser content={content} />
            )}
          </ScrollArea>
        </LogoPaper>
      </Container>
    </Stack>
  );
}
